import { ChangeDetectionStrategy, Component, DestroyRef, ElementRef, inject, OnInit, signal } from '@angular/core';

import { GoogleStreetViewComponent } from '@connect-services/client/components/immersive-view/google-street-view/google-street-view.component';
import { ImmersiveViewOverlayComponent } from '@connect-services/client/components/immersive-view/immersive-view-overlay/immersive-view-overlay.component';
import { PanoramaxComponent } from '@connect-services/client/components/immersive-view/panoramax/panoramax.component';
import { FeatureSessionService } from '@connect-services/client/services/feature-session.service';
import {
    ImmersiveViewService,
    ImmersiveViewServiceEnum,
} from '@connect-services/client/services/immersive-view/immersive-view.service';
import { ImmersiveViewUiService } from '@connect-services/client/services/immersive-view/immersive-view-ui.service';
import { FeatureSession } from '@connect-services/src/sdk/api';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [GoogleStreetViewComponent, ImmersiveViewOverlayComponent, PanoramaxComponent],
    selector: 'app-immersive-view',
    styleUrl: './immersive-view.component.scss',
    templateUrl: './immersive-view.component.html',
})
export class ImmersiveViewComponent implements OnInit {
    protected readonly ImmersiveCurrentViewEnum = ImmersiveViewServiceEnum;
    protected readonly immersiveViewService = inject(ImmersiveViewService);
    protected readonly immersiveViewUiService = inject(ImmersiveViewUiService);

    private readonly featureSessionId = signal<string | undefined>(undefined);

    // eslint-disable-next-line @typescript-eslint/member-ordering
    private readonly destroyRef = inject(DestroyRef);
    private readonly featureSessionService = inject(FeatureSessionService);
    private readonly immersiveViewContainer = inject<ElementRef<HTMLElement>>(ElementRef);

    public constructor() {
        this.immersiveViewUiService.setContainer(this.immersiveViewContainer.nativeElement);

        this.destroyRef.onDestroy(() => {
            const featureSessionId: string | undefined = this.featureSessionId();
            if (featureSessionId) {
                void this.featureSessionService.endSession(featureSessionId, false);
            }

            this.immersiveViewUiService.resetContainer();
        });
    }

    public async ngOnInit(): Promise<void> {
        this.featureSessionId.set(
            await this.featureSessionService.startFeatureSession(
                FeatureSession.FeatureTrackedEnum.GOOGLE_STREET_VIEW,
                false,
            ),
        );
    }
}
